<div class="cards-container">
  <div class="body-cards">
    <div class="container">
      <ng-container *ngFor="let data of dataCards">
        <div class="card">
          <div class="d-flex fd-row align-items-center justify-space-between w-100 border-bottom-b">
            <div class="title-card" (click)="onAction({action: 'select_card', data: data})">
              <div *ngIf="getValue(data, structure.body.icon)" class="title-card-icon" matTooltip="Registro LDAP">
                <sit-icon [icon]="getValue(data, structure.body.icon)"></sit-icon>
              </div>
              <span class="text-blue" *ngIf="structure.body.subtitle != undefined && structure.body.subtitle != null">
                {{buildText(data, structure.body.subtitle)}}
              </span>
              {{buildText(data, structure.body.title)}}
            </div>

            <div class="d-flex fd-row align-items-center gap-5-px">
              <ng-container *ngFor="let action of structure.body.title.action">
                <sit-icon class="col-sm d-flex cursor-pointer" [icon]="action.icon" [sizeClass]="'icon-size-24'" alt=""
                  [matTooltipPosition]="action.tooltip ? action.tooltip.matTooltipPosition : null"
                  [matTooltipClass]="action.tooltip ? action.tooltip.matTooltipClass : null"
                  [matTooltip]="action.tooltip ? action.tooltip.matTooltip : null"
                  (click)="action.dispatcher.next({row:data, action:action.codeAction})"></sit-icon>
              </ng-container>
            </div>
          </div>

          <div class="description" (click)="onAction({action: 'select_card', data: data})">{{buildText(data,
            structure.body.description)}}</div>
          <div class="footer">
            <div class="container-details" (click)="onAction({action: 'select_card', data: data})">
              <ng-container *ngFor="let detail of structure.details">
                <div class="details">
                  <div class="title">{{detail.title}}</div>
                  <div class="body">{{getValue(data, detail.property)}}</div>
                </div>
              </ng-container>
            </div>

            <div class="switch" *ngIf="structure.body.state != undefined">
              <!-- <mat-slide-toggle class="slide-toggle d-flex fd-col"
                                [checked]="getValue(data, structure.body.state)"
                                (change)="changeState(data, structure.body.state)"
                                [disabled]="structure.body.disabledState ? structure.body.disabledState(data) : false"
                            >
                            </mat-slide-toggle> -->
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- <div class="paginator-container">
    <div class="exports-container">
      <div class="export" *ngIf="structure.exportXLS">
        <button mat-button class="button-export" (click)="onAction({action: 'export_xls', data: undefined})">
          <div class="icon-export">
            <img src="assets/icons/download_document.svg" alt="xls download">
          </div>
          <div class="text">Exportar XLS</div>
        </button>
      </div>
      <div class="export" *ngIf="structure.exportPDF">
        <button mat-button class="button-export" (click)="onAction({action: 'export_pdf', data: undefined})">
          <div class="icon-export">
            <img src="assets/icons/download_document_pdf.svg" alt="pdf download">
          </div>
          <div class="text">Exportar PDF</div>
        </button>
      </div>
    </div>
    <sit-paginator [dataSource]="properties.dataSource"></sit-paginator>
  </div> -->
</div>
